import { Button, Checkbox, IconButton } from '@material-ui/core';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import Connector from 'connect-store';
import Switch from 'mango-ui/control/Switch';
import Selector from 'mango-ui/control/Selector';
import Title from 'mango-ui/display/Title';
import Container from 'mango-ui/layout/Container';
import * as React from 'react';
import OriginalPointsLoader from '../../classes/loaders/OriginalPointsLoader';
import CSVProcessor from '../../classes/processors/CSVProcessor';
import ParkLotGeoJSONProcessor from '../../classes/processors/ParkLotGeoJSONProcessor';
import RoadNetGeoJSONProcessor from '../../classes/processors/RoadNetGeoJSONProcessor';
import mapStore from '../../storeInstances/mapStore';
import BufferAdjustStore from '../../stores/BufferAdjustStore';
import DisjointParkPointStore from '../../stores/DisjointParkPointStore';
import FileUploaderStore from '../../stores/FileUploaderStore';
import PublisherStore from '../../stores/PublisherStore';

import RegionListStore from '../../stores/RegionListStore';
import RoadUploadStore from '../../stores/RoadUploadStore';
import SelectMapTileStore from '../../stores/SelectMapTileStore';
import FileUploaderView from '../FileUploaderView';
import ParkPointPanelView from '../ParkPointPanelView';
import PublisherView from '../PublisherView';
import { EditRegionButton, SelectRegion } from '../RegionListView';
import RoadUploadView from '../RoadUploadView';
import SelectMapTileView from '../SelectMapTileView';


import regionStore from '../../storeInstances/regionStore';
import DispatchWorkOrderLoader from "../../classes/loaders/DispatchWorkOrderLoader";
import {ChangeEvent} from "react";
import {MSID_ROAD_NET_EDITOR_LOCAL} from "../../utils/constants";

const style = require('./style.less');
const dispatchWorkOrderLoader = new DispatchWorkOrderLoader();

export interface IProps {
  editable: boolean;
  pressingAltKey: boolean;
  pressingPKey: boolean;
  pressingOKey: boolean;
  isEditParkLot: boolean;
  isEditForbidden: boolean;
  isEditRoadNet: boolean;
  isEditMeasurePoint: boolean;
  isEditPhotoPoint: boolean;
  isEditBacklogPoint: boolean;
  isMapTileVisible: boolean;
  isRegionVisible: boolean;
  isParkLotVisible: boolean;
  isHeatMapVisible: boolean;
  isDispatchWorkOrderVisible:boolean;
  isParkPointVisible: boolean;
  isRoadNetVisibility: boolean;
  isRoadNetNodesVisibility: boolean;
  isPointsToPhotoVisible: boolean;
  isPointsToMeasureVisible: boolean;
  isInspectionAreaVisible: boolean;
  isProhibitedAreaVisible: boolean;
  isForbiddenAreaVisible: boolean;
  isBacklogVisible: boolean;
  isAdjustmentVisible: boolean,
  adjustmentDefaultState: number,
  zoom: number;
  minEditableZoom: number;
  roadNetDefaultRoadType: number,
  onIsHas: IFunction;
  onIsNavShow: IFunction;
  onRefreshRemotePolygons: IFunction;
  onTogglePointsToMeasureVisibility: IFunction;
  onTogglePointsToPhotoVisibility: IFunction;
  enableAddParkingLot: boolean;
  onToggleEnableAddParkingLot: IFunction;
  enableAddRoadNet: boolean;
  enableAddBacklogPoint: boolean;
  onToggleIsMapTileVisible: IFunction;
  onToggleEnableAddRoadNet: IFunction;
  onToggleRoadNetNodesVisibility: IFunction;
  onToggleProhibitedAreaVisible: IFunction;
  onToggleForbiddenAreaVisible: IFunction;
  onToggleInspectionAreaVisible: IFunction;
  onToggleParkPointLayerVisibility: IFunction;
  onToggleParkLotVisible: IFunction;
  onToggleRegionVisible: IFunction;
  onToggleRoadNetVisibility: IFunction;
  onToggleEnableBacklogPoint: IFunction;
  onToggleHeatMapVisibility: IFunction;
  onToggleDispatchWorkOrderVisibility:IFunction;
  onIsEditPointsToMeasure: IFunction;
  onIsEditPointsToPhoto: IFunction;
  onIsEditParkLotArea: IFunction;
  onIsEditForbiddenArea: IFunction;
  onIsEditRoadNetLine: IFunction;
  onIsEditBacklogFunction: IFunction;
  onChangeShowIndex: IFunction;
  onToggleBacklogLayerVisibility: IFunction;
  onRefreshBacklogPoint: IFunction;
  onRefreshBacklogPointStock: IFunction;
  onRefreshHeatMap: IFunction;
  onSelectRoadNetRoadType: IFunction,
  onToggleAdjustmentVisible: IFunction,
  onSelectAdjustmentState: IFunction,
}

// const regionStore = new RegionListStore();
const originalPointsLoader = new OriginalPointsLoader();
const items = ['固定解', '浮动解', '码差分', '单点', '广域', '无解'];
const colors = ['#00ca35', '#94d945', '#ffff58', '#ffae42', '#ff062a', '#000'];
const roadTypes = [{ label: '乱停路线', value: 0 }, { label: '扣押路线', value: 1 }];
const adjustmentState = [{ label: '待处理', value: 0 }, { label: '已完成', value: 1 }];


// function getDispatchStartDate (e: ChangeEvent<HTMLInputElement>): void {
//   console.log(e.target.value); // 获取到输入框的值
//   // dispatchWorkOrderLoader.fetchDispatchOrder(e.target.value);
// }

let dispatchObj = {
  startDispatchDate:"",
  endDispatchDate:"",
}
function getDispatch () {
  dispatchWorkOrderLoader.clear();
  dispatchWorkOrderLoader.fetchDispatchOrder(dispatchObj.startDispatchDate,dispatchObj.endDispatchDate);
}


export default ({
  editable, zoom, minEditableZoom, pressingAltKey, isParkPointVisible, isEditParkLot,isEditForbidden, isMapTileVisible,
  pressingPKey, isRegionVisible, isPointsToPhotoVisible, isPointsToMeasureVisible, isBacklogVisible, onRefreshBacklogPointStock,
  pressingOKey, onRefreshRemotePolygons, onTogglePointsToMeasureVisibility, onIsNavShow, onIsHas, onRefreshBacklogPoint, onToggleHeatMapVisibility, isHeatMapVisible,isDispatchWorkOrderVisible,onToggleDispatchWorkOrderVisibility,
  onTogglePointsToPhotoVisibility, enableAddParkingLot, onToggleEnableAddParkingLot, enableAddRoadNet, isEditBacklogPoint, onIsEditBacklogFunction, onRefreshHeatMap
  , onToggleRoadNetNodesVisibility, isRoadNetNodesVisibility, isParkLotVisible, isInspectionAreaVisible, onToggleBacklogLayerVisibility, onToggleEnableBacklogPoint, enableAddBacklogPoint
  , onToggleIsMapTileVisible, onToggleEnableAddRoadNet, isEditMeasurePoint, isEditRoadNet, onIsEditRoadNetLine, onIsEditParkLotArea,onIsEditForbiddenArea, isEditPhotoPoint, onIsEditPointsToPhoto,
  onIsEditPointsToMeasure, onToggleRoadNetVisibility, isRoadNetVisibility, onToggleParkPointLayerVisibility, onToggleInspectionAreaVisible, onToggleRegionVisible, onChangeShowIndex,
  isProhibitedAreaVisible, isForbiddenAreaVisible, onToggleParkLotVisible, onToggleProhibitedAreaVisible, onToggleForbiddenAreaVisible, onSelectRoadNetRoadType, roadNetDefaultRoadType,
  isAdjustmentVisible, onToggleAdjustmentVisible, adjustmentDefaultState, onSelectAdjustmentState,
}: IProps) => {
  return (
    <div
      style={{ width: 350, marginTop: 10, marginRight: 10, backgroundColor: 'white', overflowY: 'auto', padding: '10px 15px 200px 0px ' }}
    >
      <div style={{ marginLeft: '15px' }}>
        <Connector
          View={PublisherView}
          store={new PublisherStore()}
        />
        <Connector
          View={SelectRegion}
          store={regionStore}
        />
        <div style={{ marginTop: 20, background: '#96befb', padding: 8, borderRadius: 5 }}>
          <h3>地图选项</h3>
          <Switch
            active={isMapTileVisible}
            onToggle={onToggleIsMapTileVisible}
            label={'是否展示地图底图'}
          />
          <Connector
            View={SelectMapTileView}
            store={new SelectMapTileStore()}
          />
          <Connector store={new RoadUploadStore()} View={RoadUploadView}/>
          <p
            style={{ color: 'red' }}
          >
            车道采集数据需要同时上传
            ChainFurniture.json、HADRoad.json、HADLaneDivider.json、HADLanePolygon.json文件，
            注意文件命名需要一致
          </p>
        </div>
        <div style={{ marginTop: 20, background: '#96befb', padding: 8, borderRadius: 5 }}>
          <h3>点吸附选项</h3>
          <Connector
            label="点击上传原始点数据CSV文件"
            accept="text/csv"
            View={FileUploaderView}
            store={new FileUploaderStore(new CSVProcessor())}
          />
          <button onClick={originalPointsLoader.clear.bind(originalPointsLoader)}>清除原始点</button>
          <Container className="control-original-positions-legend">
            <Title>图例</Title>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {items.map((name, index) => {
                return (
                  <p key={index} style={{ width: '50%' }}>
                    <span style={{ color: colors[index] }}>+</span>&nbsp;&nbsp;
                    {name}
                  </p>
                );
              })}
            </div>

          </Container>
        </div>
      </div>
      <div className={style.box}>
        <div className={style.option}>
          <div>
            <Checkbox
              checked={isRegionVisible}
              onChange={onToggleRegionVisible}
            />
            <h3>大区围栏</h3>
          </div>
          <IconButton onClick={() => onIsNavShow('大区')}>{onIsHas('大区') ? <ArrowDropUp/> :
            <ArrowDropDown/>}</IconButton>
        </div>
        {onIsHas('大区') ? <div className={style.control}>
          <Connector
            View={EditRegionButton}
            store={regionStore}
          />
        </div> : null}
      </div>
      <div className={style.box}>
        <div className={style.option}>
          <div>
            <Checkbox
              checked={isInspectionAreaVisible}
              onChange={onToggleInspectionAreaVisible}
            />
            <h3>巡检区</h3>
          </div>
          <IconButton onClick={() => onIsNavShow('巡检区')}>{onIsHas('巡检区') ? <ArrowDropUp/> :
            <ArrowDropDown/>}</IconButton>
        </div>
      </div>
      <div className={style.box}>
        <div className={style.option}>
          <div>
            <Checkbox
              checked={isProhibitedAreaVisible}
              onChange={onToggleProhibitedAreaVisible}
            />
            <h3>禁行区</h3>
          </div>
          <IconButton onClick={() => onIsNavShow('禁行区')}>{onIsHas('禁行区') ? <ArrowDropUp/> :
            <ArrowDropDown/>}</IconButton>
        </div>
      </div>
      <div className={style.box}>
        <div className={style.option}>
          <div>
            <Checkbox
              checked={isForbiddenAreaVisible}
              onChange={onToggleForbiddenAreaVisible}
            />
            <h3>禁停区</h3>
          </div>
          <IconButton onClick={() => onIsNavShow('禁停区')}>{onIsHas('禁停区') ? <ArrowDropUp/> :
            <ArrowDropDown/>}</IconButton>
        </div>
        {onIsHas('禁停区') ?
            <div className={style.control}>
              <div>
                <Button
                    style={{ marginRight: '5px' }}
                    variant="outlined"
                    onClick={onIsEditForbiddenArea}
                >
                  {isEditForbidden ? '退出编辑' : '编辑'}
                </Button>
              </div>
            </div> : null}
      </div>
      <div className={style.box}>
        <div className={style.option}>
          <div>
            <Checkbox
              checked={isParkLotVisible}
              onChange={onToggleParkLotVisible}
            />
            <h3>停车区</h3>
          </div>
          <IconButton onClick={() => onIsNavShow('停车区')}>{onIsHas('停车区') ? <ArrowDropUp/> :
            <ArrowDropDown/>}</IconButton>
        </div>
        {onIsHas('停车区') ?
          <div className={style.control}>
            <Button
              style={{ marginRight: '5px' }}
              variant="outlined"
              onClick={onIsEditParkLotArea}
            >
              {isEditParkLot ? '退出编辑' : '编辑'}
            </Button>
            <Button
              variant="outlined"
              onClick={onToggleEnableAddParkingLot}
            >
              {enableAddParkingLot ? '退出创建' : '创建'}
            </Button>
            <div style={{ margin: '5px 0' }}>
              <Button
                variant="outlined"
                onClick={onRefreshRemotePolygons}
              >
                刷新停车区
              </Button>
            </div>
            <Connector
              store={[mapStore, new BufferAdjustStore(), new DisjointParkPointStore()]}
              View={ParkPointPanelView}
            />
            <Connector
              label="点击上传GeoJSON文件"
              accept="application/json"
              store={new FileUploaderStore(new ParkLotGeoJSONProcessor())}
              View={FileUploaderView}
            />
          </div> : null}
      </div>
      <div className={style.box}>
        <div className={style.option}>
          <div>
            <Checkbox
              checked={isRoadNetVisibility}
              onChange={onToggleRoadNetVisibility}
            />
            <h3>路网</h3>
          </div>
          <IconButton onClick={() => onIsNavShow('路网')}>{onIsHas('路网') ? <ArrowDropUp/> :
            <ArrowDropDown/>}</IconButton>
        </div>
        {onIsHas('路网') ?
          <div className={style.control}>
            <Switch
              active={isRoadNetNodesVisibility}
              onToggle={onToggleRoadNetNodesVisibility}
              label={<span style={{ color: 'red' }}>是否展示路网节点</span>}
            />

            <Button
              style={{ marginRight: 5 }}
              variant="outlined"
              onClick={onIsEditRoadNetLine}
            >
              {isEditRoadNet ? '退出编辑' : '编辑'}
            </Button>
            <Selector
              options={roadTypes}
              value={roadTypes[roadNetDefaultRoadType]}
              defaultValue={roadTypes[roadNetDefaultRoadType]}
              onChangeValue={onSelectRoadNetRoadType}
            >
            </Selector>
            <Button
              variant="outlined"
              onClick={onToggleEnableAddRoadNet}
            >
              {enableAddRoadNet ? '退出创建' : '创建'}
            </Button>
            <Connector
              label="点击上传路网GeoJSON文件"
              accept="application/json"
              store={new FileUploaderStore(new RoadNetGeoJSONProcessor())}
              View={FileUploaderView}
            />
          </div> : null}
      </div>
      <div className={style.box}>
        <div className={style.option}>
          <div>
            <Checkbox
              checked={isPointsToPhotoVisible}
              onClick={onTogglePointsToPhotoVisibility}
            />
            <h3>照片点</h3>
          </div>
          <IconButton onClick={() => onIsNavShow('照片点')}>{onIsHas('照片点') ? <ArrowDropUp/> :
            <ArrowDropDown/>}</IconButton>
        </div>
        {onIsHas('照片点') ?
          <div className={style.control}>
            <Button
              variant="outlined"
              onClick={onIsEditPointsToPhoto}
            >
              {isEditPhotoPoint ? '退出创建' : '创建'}
            </Button>
          </div> : null}
      </div>
      <div className={style.box}>
        <div className={style.option}>
          <div>
            <Checkbox
              checked={isPointsToMeasureVisible}
              onChange={onTogglePointsToMeasureVisibility}
            />
            <h3>测量点</h3>
          </div>
          <IconButton onClick={() => onIsNavShow('测量点')}>{onIsHas('测量点') ? <ArrowDropUp/> :
            <ArrowDropDown/>}</IconButton>
        </div>
        {onIsHas('测量点') ?
          <div className={style.control}>
            <div>（鼠标左键添加、右键删除，拖拽移动）</div>
            <Button
              variant="outlined"
              onClick={onIsEditPointsToMeasure}
            >
              {isEditMeasurePoint ? '退出编辑' : '编辑'}
            </Button>
          </div> : null}
      </div>
      <div className={style.box}>
        <div className={style.option}>
          <div>
            <Checkbox
              checked={isBacklogVisible}
              onChange={onToggleBacklogLayerVisibility}
            />
            <h3>积压点</h3>
          </div>
          <IconButton onClick={() => onIsNavShow('积压点')}>{onIsHas('积压点') ? <ArrowDropUp/> :
            <ArrowDropDown/>}</IconButton>
        </div>
        {onIsHas('积压点') ?
          <div className={style.control}>
            <div>（鼠标左键添加、右键删除，拖拽移动）</div>
            <div>
              <Button
                variant="outlined"
                onClick={onRefreshBacklogPoint}
              >
                刷新积压点
              </Button>
              <Button variant="outlined" onClick={onRefreshBacklogPointStock}>刷新积压点车辆信息</Button>
            </div>
            <Button
              variant="outlined"
              onClick={onIsEditBacklogFunction}
            >
              {isEditBacklogPoint ? '退出编辑' : '编辑'}
            </Button>
            <Button
              variant="outlined"
              onClick={onToggleEnableBacklogPoint}
            >
              {enableAddBacklogPoint ? '退出创建' : '创建'}
            </Button>
          </div> : null}
      </div>
      <div className={style.box}>
        <div className={style.option}>
          <div>
            <Checkbox
              checked={isAdjustmentVisible}
              onChange={onToggleAdjustmentVisible}
            />
            <h3>调整项</h3>
          </div>
          <IconButton onClick={() => onIsNavShow('调整项')}>{onIsHas('调整项') ? <ArrowDropUp/> :
            <ArrowDropDown/>}</IconButton>
        </div>
        {
          onIsHas('调整项') ? <div className={style.control}>
            <div className={style.control}>
              <Selector
                options={adjustmentState}
                value={adjustmentState[adjustmentDefaultState]}
                defaultValue={adjustmentState[adjustmentDefaultState]}
                onChangeValue={onSelectAdjustmentState}
              >
              </Selector>
            </div>
          </div> : null
        }
      </div>
      <div className={style.box}>
        <div className={style.option}>
          <div>
            <Checkbox
              checked={isHeatMapVisible}
              onChange={onToggleHeatMapVisibility}
            />
            <h3>热力图</h3>
          </div>
          <IconButton onClick={() => onIsNavShow('热力图')}>{onIsHas('热力图') ? <ArrowDropUp/> :
            <ArrowDropDown/>}</IconButton>
        </div>
        {onIsHas('热力图') ?
          <div className={style.control}>
            <div>
              <Button
                variant="outlined"
                onClick={onRefreshHeatMap}
              >
                刷新
              </Button>
            </div>
          </div> : null}
      </div>
      <div className={style.box}>
        <div className={style.option}>
          <div>
            <Checkbox
                checked={isDispatchWorkOrderVisible}
                onChange={onToggleDispatchWorkOrderVisibility}
            />
            <h3>减免调度费订单</h3>
          </div>
          <IconButton onClick={() => onIsNavShow('减免调度费订单')}>{onIsHas('减免调度费订单') ? <ArrowDropUp/> : <ArrowDropDown/>}</IconButton>
        </div>
        {onIsHas('减免调度费订单') ?
            <div className={style.control}>
              <div>
                <p>提交开始时间:<input id="startDispatchDate" type="datetime-local" onBlur={(e: ChangeEvent<HTMLInputElement>)=>{dispatchObj.startDispatchDate = e.target.value}}/>
                </p>
                <p>提交结束时间:<input id="endDispatchDate" type="datetime-local" onBlur={(e: ChangeEvent<HTMLInputElement>)=>{dispatchObj.endDispatchDate = e.target.value}}/></p>
                <Button variant="outlined" onClick={getDispatch}>
                  确定
                </Button>
              </div>
            </div> : null}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/views/layerPanelView/LayerPanelView.tsx